import { render, staticRenderFns } from "./UnbindServer.vue?vue&type=template&id=fb39b68c"
import script from "./UnbindServer.vue?vue&type=script&lang=js"
export * from "./UnbindServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports